export default __webpack_public_path__ + "static/media/keyvisual-bamberg.84165a48.jpg";